<script setup lang="ts">
import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { AlertDialogAction, type AlertDialogActionProps } from 'reka-ui'

interface Props extends AlertDialogActionProps {
    variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'link' | 'ghost' | 'icon'
}

const props = defineProps<Props>()
</script>

<template>
    <AlertDialogAction v-bind="props" :class="cn(buttonVariants({ variant }), $attrs.class ?? '')">
        <slot />
    </AlertDialogAction>
</template>
